<script setup>
import { computed, inject, ref, watch } from 'vue'
import { useDetailsReport } from '#/detailsReport/useDetailsReport'

const { global, pages, application, screen } = inject('Shared')
const { demo } = useDetailsReport()
const showMore = ref(false)
const showBtn = ref(true)
watch(showMore, value => {
  if (!value) {
    setTimeout(() => {
      showBtn.value = true
    }, 1000)
  } else {
    showBtn.value = false
  }
})

function toggleItem (label) {
  pages.value.detailReport.firstSteps.checklist.items = pages.value.detailReport.firstSteps.checklist.items.map(item => {
    if (item.label === label) {
      item.selected = !item.selected
    } else {
      item.selected = false
    }
    return item
  })
}

const selectedItem = computed(() => {
  const res = pages.value.detailReport.firstSteps.checklist.items.find(e => e.selected)
  if (res) {
    return res
  }
  return pages.value.detailReport.firstSteps.checklist.items[0]
})

const containerClosed = ref(true)
const btnRotate = computed(() => {
  if (containerClosed.value) {
    return 'rotate(0deg)'
  }
  return 'rotate(180deg)'
})
</script>

<template lang="pug">
.checkListContainer(v-if="pages.detailReport.firstSteps.checklist && !demo" :class="containerClosed ? 'checklist--closed-container' : ''")
  .main-text--container
    .checklist--main-text {{ pages.detailReport.firstSteps.checklist.title }}
    .checklist--close-btn(@click="containerClosed = !containerClosed")
      .checklist--close-btn-label {{ containerClosed ? 'öffnen' : 'schliessen' }}
      .checklist--close-btn-svg
        svg(width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M7.71045 7.54023L13.3605 1.88023C13.4542 1.78726 13.5286 1.67666 13.5793 1.5548C13.6301 1.43294 13.6562 1.30224 13.6562 1.17023C13.6562 1.03821 13.6301 0.907509 13.5793 0.785649C13.5286 0.66379 13.4542 0.553189 13.3605 0.460226C13.1731 0.273975 12.9196 0.169434 12.6555 0.169434C12.3913 0.169434 12.1378 0.273975 11.9505 0.460226L6.95045 5.41023L2.00045 0.460226C1.81309 0.273975 1.55964 0.169433 1.29545 0.169433C1.03127 0.169433 0.777815 0.273975 0.590452 0.460225C0.495964 0.55284 0.420794 0.663285 0.369297 0.78516C0.3178 0.907036 0.291002 1.03792 0.290453 1.17023C0.291002 1.30253 0.3178 1.43342 0.369297 1.55529C0.420793 1.67717 0.495964 1.78761 0.590452 1.88023L6.24045 7.54023C6.33409 7.64173 6.44774 7.72274 6.57424 7.77815C6.70074 7.83355 6.83735 7.86216 6.97545 7.86216C7.11355 7.86216 7.25016 7.83355 7.37666 7.77815C7.50316 7.72274 7.61681 7.64173 7.71045 7.54023Z' fill='#626C85')
  .bodyText {{ pages.detailReport.firstSteps.checklist.subtitle }}
  .checkListItemsContainer.row
    .col-lg-6.col-md-6.col-sm-12.col-xs-12.checkListItem(v-for="item in pages.detailReport.firstSteps.checklist.items" :key="item.label" @click="toggleItem(item.label)")
      svg.checkListSvg(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' v-if="!item.selected")
        path(d='M7 11.8636L10.6111 16L17 9' :stroke="application === 'WIDGET' ? global.graphicElementColor: '#007BFF'" stroke-linecap='round')
        circle(cx='12' cy='12' r='11.5' :stroke="application === 'WIDGET' ? global.graphicElementColor: '#007BFF'")
      svg.checkListSvg(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' v-else)
        path(d='M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z' :fill="application === 'WIDGET' ? global.graphicElementColor: '#007BFF'" :stroke="application === 'WIDGET' ? global.graphicElementColor: '#007BFF'")
        path(d='M7 11.8636L10.6111 16L17 9' stroke='white' stroke-linecap='round')
      .label(:style="item.selected ? 'color: #007BFF !important' : ''") {{ item.label }}
  .bottomContainer
    .svgContainer
      svg.svg(width='16' height='21' viewBox='0 0 16 21' fill='none' xmlns='http://www.w3.org/2000/svg')
        path(d='M5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8ZM11 10H5C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10ZM11 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14ZM15.71 18.29C15.6625 18.247 15.6124 18.2069 15.56 18.17C15.5043 18.1322 15.4437 18.1019 15.38 18.08L15.2 18C15.005 17.9619 14.8031 17.9828 14.62 18.06C14.4959 18.1049 14.3832 18.1766 14.2899 18.2699C14.1966 18.3632 14.1249 18.4759 14.08 18.6C14.0209 18.7247 13.9934 18.8621 14 19C13.9983 19.1488 14.0297 19.296 14.0921 19.4311C14.1545 19.5662 14.2462 19.6856 14.3606 19.7807C14.475 19.8758 14.6092 19.9442 14.7534 19.9809C14.8976 20.0176 15.0481 20.0216 15.1941 19.9927C15.34 19.9638 15.4777 19.9028 15.597 19.8139C15.7164 19.7251 15.8144 19.6107 15.8839 19.4792C15.9535 19.3477 15.9928 19.2023 15.9991 19.0537C16.0053 18.905 15.9783 18.7569 15.92 18.62C15.8694 18.4988 15.7983 18.3872 15.71 18.29ZM16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H11C11.2652 20 11.5196 19.8946 11.7071 19.7071C11.8946 19.5196 12 19.2652 12 19C12 18.7348 11.8946 18.4804 11.7071 18.2929C11.5196 18.1054 11.2652 18 11 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V10C14 10.2652 14.1054 10.5196 14.2929 10.7071C14.4804 10.8946 14.7348 11 15 11C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10V7C16 7 16 7 16 6.94ZM11 6C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41L12.59 6H11ZM15 13C14.7348 13 14.4804 13.1054 14.2929 13.2929C14.1054 13.4804 14 13.7348 14 14V16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16V14C16 13.7348 15.8946 13.4804 15.7071 13.2929C15.5196 13.1054 15.2652 13 15 13Z' fill='white')
    .containerContent(:class="showMore ? 'showMoreContent' : ''")
      .textsContainer
        .normalText
          span(v-html="selectedItem.notExpandedText")
          span.mehrText.gt-sm(v-if="showBtn" @click="showMore = true") Mehr erfahren.
          .mehrText.lt-md(v-if="showBtn" @click="showMore = true") Mehr erfahren.
      .hiddenContent(v-if="selectedItem")
        .normalText(v-html="selectedItem.expandedText")
        .showLess(@click="showMore = false") Weniger anzeigen.
</template>

<style lang="sass" scoped>
.checklist--closed-container
  overflow: hidden
  @media screen and (min-width: 600px)
    max-height: 60px !important
  @media screen and (max-width: 600px)
    max-height: 76px !important
.checkListContainer
  background: rgba(255, 255, 255, 0.7)
  border: 1px solid #D9D9D9
  box-sizing: border-box
  box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
  border-radius: 10px
  max-height: 3000px
  transition: all 0.7s ease
  @media screen and (min-width: 1024px)
    margin-top: 30px
    padding: 21px
  @media screen and (max-width: 1023px)
    padding: 20px
    margin-top: 15px
  .main-text--container
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    @media screen and (min-width: 1024px)
      margin-bottom: 21px
    @media screen and (max-width: 1023px)
      margin-bottom: 26px
    .checklist--main-text
      font-weight: 700
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 16px
        line-height: 130%
      @media screen and (max-width: 1023px) and (min-width: 401px)
        line-height: 18px
        font-size: 14px
      @media screen and (max-width: 400px)
        font-size: 12px
    .checklist--close-btn
      display: flex
      flex-direction: row
      align-items: center
      cursor: pointer
      .checklist--close-btn-label
        font-weight: 500
        line-height: 130%
        margin-right: 6px
        color: #626C85
        @media screen and (min-width: 1024px)
          font-size: 16px
        @media screen and (max-width: 1023px)
          font-size: 14px
      .checklist--close-btn-svg
        display: flex
        justify-content: center
        align-items: center
        transform: v-bind(btnRotate)
        transition: all 0.5s ease-in-out
        .svg
          fill: #626C85
          @media screen and (min-width: 1024px)
            width: 14px
            height: 21px
          @media screen and (max-width: 1023px)
            width: 12px
            height: 18px
  .bodyText
    font-weight: 500
    font-size: 16px
    line-height: 130%
    color: #626C85
    margin-bottom: 35px
  .checkListItemsContainer
    width: 100%
    @media screen and (min-width: 1024px)
      padding: 0 60px 0px 60px
    @media screen and (max-width: 1023px)
    .checkListItem
      display: flex
      flex-direction: row
      align-items: center
      padding: 7.5px 0
      cursor: pointer
      .checkListSvg
        min-width: 30px
        margin-right: 15px
        width: 24px
        height: 24px
      .label
        font-weight: 500
        font-size: 16px
        line-height: 130%
        color: #626C85
  .bottomContainer
    background: white
    border: 1px solid #D9D9D9
    box-sizing: border-box
    backdrop-filter: blur(40px)
    border-radius: 10px
    padding: 30px
    position: relative
    margin-top: 30px
    @media screen and (min-width: 1024px)
      padding: 30px
    @media screen and (max-width: 1023px)
      padding: 30px 20px 20px 20px
    .svgContainer
      background: #007BFF
      backdrop-filter: blur(20px)
      border-radius: 4px
      width: 34px
      height: 34px
      position: absolute
      display: flex
      justify-content: center
      align-items: center
      @media screen and (min-width: 1024px)
        top: -17px
        left: 25px
      @media screen and (max-width: 1023px)
        top: -17px
        left: 20px
      .svg
        width: 16px
        height: 20px
    .showMoreContent
      max-height: 1000px !important
    .containerContent
      overflow-y: hidden
      transition: max-height 1s ease
      @media screen and (min-width: 1024px)
        max-height: 40px
      @media screen and (max-width: 1023px)
        max-height: 140px
      .normalText
        font-weight: 500
        font-size: 16px
        line-height: 130%
        color: #5C5C73
      .textsContainer
        display: flex
        flex-direction: row
        .mehrText
          color: v-bind('pages.detailReport.firstSteps.checklist.askMoreColor')
          cursor: pointer
          @media screen and (min-width: 1024px)
            margin-left: 6px
          @media screen and (max-width: 1023px)
            width: 100%
            font-weight: 600 !important
      .hiddenContent
        margin-top: 20px
        .redText
          margin-top: 20px
          color: #EB604F
        .showLess
          margin-top: 20px
          font-weight: 600
          font-size: 14px
          line-height: 130%
          color: #626C85
          cursor: pointer
</style>
